import { HeartBeatRequestBody } from 'src/common/interfaces/heartbeat';
import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postHeartBeat: builder.mutation<ApiResponse, HeartBeatRequestBody>({
      query: ({ ...body }) => ({
        url: '/heartbeats',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostHeartBeatMutation } = extendedApiSlice;
